(() => {
  if (customElements.get('prink-complete-pack')) return;
  customElements.define('prink-complete-pack', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.items = JSON.parse(this.dataset.items);
      this.unavailable = this.dataset.available === 'false';
      this.input = this.querySelector('[data-quantity]');
      this.button = this.querySelector('[data-add-pack]');
      this.status = this.querySelector('[role="status"]');
      this.input.addEventListener('input', () => this.updatePrice(), {signal:this.abort.signal});
      this.button.addEventListener('click', () => this.add(), {signal:this.abort.signal});
      this.updatePrice();
    }
    disconnectedCallback() { this.abort?.abort(); }
    quantity() { const value = Number(this.input.value); return Number.isInteger(value) && value >= 1 && value <= 99 ? value : null; }
    money(value) { return new Intl.NumberFormat(document.documentElement.lang || 'es',{style:'currency',currency:this.dataset.currency}).format(value / 100); }
    updatePrice() {
      const quantity = this.quantity();
      this.button.disabled = this.busy || this.unavailable || quantity === null;
      if (quantity === null) return;
      const total = this.items.reduce((sum,item) => sum + item.price * quantity,0);
      this.querySelector('[data-total]').textContent = this.dataset.totalLabel.replace('__amount__',this.money(total));
      const promo = this.querySelector('[data-promo-text]');
      if (promo) {
        const eligible = this.items.filter(item => item.eligible);
        const eligibleTotal = eligible.reduce((sum,item) => sum + item.price * quantity,0);
        const saving = eligible.reduce((sum,item) => sum + Math.floor(item.price * .15) * quantity,0);
        promo.textContent = eligibleTotal >= 2500 ? this.dataset.promoLabel.replace('__amount__',this.money(total-saving)).replace('__saving__',this.money(saving)) : this.dataset.minimumLabel;
      }
    }
    async add() {
      if (this.busy || this.unavailable || !this.quantity()) return;
      const quantity = this.quantity();
      this.busy = true; this.updatePrice(); this.input.disabled = true; this.status.textContent = '';
      const drawer = document.querySelector('cart-drawer');
      try {
        const rec = window.PrinkRecommendations;
        const recContext = rec?.context('complete_pack',this.dataset.family,'product');
        const items = this.items.map(item => ({id:item.id,quantity}));
        const body = {items};
        if (drawer) { body.sections = drawer.getSectionsToRender().map(section => section.id); body.sections_url = window.location.pathname; }
        const options={method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)};
        const response=await (rec ? rec.fetchAdd(this.dataset.addUrl,options,recContext,items) : fetch(this.dataset.addUrl,options));
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.dataset.errorLabel);
        if (drawer) this.renderDrawer(drawer,data);
        else { window.location.assign(this.dataset.cartUrl); return; }
        if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'prink-complete-pack',cartData:data});
        this.status.textContent = this.dataset.successLabel;
      } catch (error) {
        // Stock changes can cause a partial multi-item addition; show the actual cart before retrying.
        try {
          if (drawer) {
            const url = new URL(window.location.href);
            url.searchParams.set('sections',drawer.getSectionsToRender().map(section => section.id).join(','));
            const refreshed = await fetch(url,{headers:{Accept:'application/json'}});
            if (refreshed.ok) this.renderDrawer(drawer,{sections:await refreshed.json()});
          }
          if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'prink-complete-pack-error'});
        } catch (_) {}
        this.status.textContent = `${error.message || this.dataset.errorLabel} ${this.dataset.errorLabel}`;
      } finally { this.busy = false; this.input.disabled = false; this.updatePrice(); }
    }
    renderDrawer(drawer,data) {
      const html = data.sections?.['cart-drawer'];
      if (typeof html === 'string') {
        const content = new DOMParser().parseFromString(html,'text/html');
        drawer.classList.toggle('is-empty',!content.querySelector('#CartDrawer .cart-item'));
      }
      drawer.renderContents(data);
    }
  });
})();

